<template>
  <div class="container1">
    <div class="top-box-s-wrapper">
      <div class="top-box-s-bg"></div>
      <div class="top-box-s">
        <div class="search"></div>
        <div class="banner"></div>
      </div>
    </div>

    <div class="nav-list new-home-nav-box">
      <div class="nav-item">
        <div class="nav-item-sec"></div>
      </div>
      <div class="nav-item">
        <div class="nav-item-sec"></div>
      </div>
      <div class="nav-item">
        <div class="nav-item-sec"></div>
      </div>
      <div class="nav-item">
        <div class="nav-item-sec"></div>
      </div>
    </div>
    <div class="nav-list new-home-nav-box">
      <div class="nav-item">
        <div class="nav-item-sec"></div>
      </div>
      <div class="nav-item">
        <div class="nav-item-sec"></div>
      </div>
      <div class="nav-item">
        <div class="nav-item-sec"></div>
      </div>
      <div class="nav-item">
        <div class="nav-item-sec"></div>
      </div>
    </div>
    <div class="banner" style="height: 29.33333vw;"></div>
    <div class="yuan-box">
      <div class="title-box justify-align">
        <div class="lf"><span></span><span class="span-sec"></span></div>
        <div class="rt-box"></div>
      </div>
      <div class="nav-list-box">
        <div class="nav-list new-home-nav-box">
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
        </div>
      </div>

    </div>
    <div class="yuan-box">
      <div class="title-box justify-align">
        <div class="lf"><span></span></div>
        <div class="rt-box" style="width: 12vw;height: 4vw;"></div>
      </div>
      <div class="nav-list-box">
        <div class="nav-list new-home-nav-box">
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
          <div class="nav-item">
            <div class="nav-item-sec"></div>
          </div>
        </div>
      </div>

    </div>
<!--    <ul>-->
<!--      <li></li>-->
<!--    </ul>-->
<!--    <div class="banner" style="height: 29.33333vw;"></div>-->
<!--    <div class="banner" style="height: 29.33333vw;"></div>-->
  </div>
</template>

<script>
export default {
name: "skeletonIndex"
}
</script>

<style lang="scss" scoped>
.container1{
  animation: skeleton-blink 1.2s ease-in-out infinite;
}
.top-box-s-wrapper{
  position: relative;
  .top-box-s-bg{
    position: absolute;width: 100%;height: 320px;background: #cccccc;padding-top: 30px;
    top: 0;left: 0;
  }
  .top-box-s{
    position: relative;padding-top: 30px;
  }
  .search{

    background-color: #e5e5e5;
    height: 70px;width: 90%;margin: 0 auto 20px;border-radius: 50px;
  }
}

.banner{
  //width: 750px;overflow: hidden;
  width: 90%;margin: 20px auto;
  height: 340px;
  background-color: #e5e5e5;
  // animation: loading 2s linear infinite;
  //    background-image: linear-gradient(90deg, #e8e7e7, #e8e7e7 52%, #f1f1f1 55%, #e8e7e7 58%, #e8e7e7);
  //    background-size: 400% 100%;

  border-radius: 20px;

}
.new-home-nav-box{
  flex-wrap: wrap;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 92%;margin: 40px auto;
  .nav-item{
    width: 25%;
    .nav-item-sec{
      text-align: center;
      background-color: #e5e5e5;
      height: 150px;
      width: 90%;border-radius: 50%;
    }
  }
}
.yuan-box{
  width: 92%;margin: 40px auto;
  background-color: #fff;
  border-radius: 10px;
  .title-box{
    padding: 20px 30px;
    .lf{
      span{
        background-color: #eaeaea;
        height:40px;display: inline-block;width: 200px;border-radius: 150px;
      }
      .span-sec{
        margin-left: 10px;width: 100px;height:20px;
      }
    }
    .rt-box{
      background-color: #eaeaea;
      height:20px;width:100px;border-radius: 150px;
    }
  }
  .nav-list-box{
    padding: 0 20px;
  }
  .new-home-nav-box{
    flex-wrap: wrap;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 20px auto 0;padding-bottom: 20px;
    width: 100%;
    .nav-item{
      width: 20%;
      .nav-item-sec{
        text-align: center;
        background-color: #e5e5e5;
        height:120px;
        margin: 0 auto;width: 90%;
        border-radius: 0;
      }
    }
  }
}

@keyframes loading {
  0% {
    background-position: 400% 50%
  }
  to {
    background-position: 0% 50%
  }
}

@keyframes skeleton-blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
li{
  background-image: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
  width: 100%;
  height: 0.6rem;
  list-style: none;
  background-size: 400% 100%;
  background-position: 100% 50%;
  animation: skeleton-loading 1.4s ease infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

</style>
